module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedicationPage",
    attrs: {
      "id": "ded"
    }
  }, [_c('p', {
    staticClass: "dedicationTextCenter"
  }, [_c('span', [_vm._v("To Dan Foley of Hawaii,"), _c('br'), _vm._v("\nMary Bonauto of GLAD, Jon Davidson of Lambda Legal,"), _c('br'), _vm._v("\nTim Sweeney of the Evelyn & Walter Haas Jr. Fund,"), _c('br'), _vm._v("\nand my many other gay and non-gay friends and colleagues"), _c('br'), _vm._v("\nin the lesbian and gay civil rights movement")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f000236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781416583226_ded.vue
// module id = 63
// module chunks = 0